import React, {ChangeEvent, FC} from 'react';
import { Buttons, Form, FormElements } from '../../../common/AddEditFormLayout/AddEditFormLayout.styles';
import {
    DropdownWrapperLarge,
    DropdownWrapperMedium,
} from '../../../common/FormElementWrappers/FormElementWrappers.styles';
import Header from '../../../common/Header/Header';
import { H2 } from '../../../common/Headings/Headings.styles';
import Button from '../../../components/Button/Button';
import Dropdown from '../../../components/Dropdown/Dropdown';
import {RowWrapper } from './ClassSizeForm.styles';
import { ClassSizeFormProps} from './ClassSizeForm.types';
import {OPTIONS_PLACEHOLDER} from "../../../constants/Dropdown";
import {useClasses} from "../../../services/class/class.service";
import {Class} from "../../../services/class/class.types";
import {useSizes} from "../../../services/size/size.service";
import {Size} from "../../../services/size/size.types";
import { HorizontalLine } from '../../Classes/ClassForm/ClassForm.styles';
import ImageForm from '../../../components/ImageForm/ImageForm';

const ClassSizeForm: FC<ClassSizeFormProps> = ({
                                                   headerTitle,
                                                   formValues,
                                                   formErrors,
                                                   setFormErrors,
                                                   setFormValues,
                                                   handleSave,
                                                   saveDisabled,
                                                   isButtonLoading,
                                                   isFormReadOnly = false,
                                                   hasImageForm = false,
                                               }) => {

    // fetch classes and map to dropdown options
    const { data: classesData } = useClasses(true);
    const allClasses = classesData?.data || [];
    const classOptions = allClasses.map((item: Class) => {
        return { value: item?.classNo?.toString(), label: `${item?.classNo} - ${item?.description}` };
    });

    // fetch sizes and map to dropdown options
    const { data: sizesData } = useSizes(true);
    const allSizes = sizesData?.data || [];
    const sizeOptions = allSizes.map((item: Size) => {
        return { value: item?.sizeNo?.toString(), label: `${item?.sizeNo} - ${item?.description}` };
    });
    const handleDropDown = (event: ChangeEvent<HTMLSelectElement>) => {
        setFormValues({ ...formValues, [event.target.id]: event.target.value });
        setFormErrors && setFormErrors({ ...formErrors, [event.target.id]: '' });
    };

    return (
        <>
            <Header
                breadcrumb={{label: 'Back to ClassSize Table', to: '/tables/classsizes'}}
                title={headerTitle}
            />
            <Form>
                <FormElements>
                    <H2>ClassSize Table</H2>
                    <RowWrapper>
                        <DropdownWrapperMedium>
                            <Dropdown
                                label='MOA Class Number'
                                id='classNo'
                                options={classOptions}
                                value={formValues?.classNo?.toString() || OPTIONS_PLACEHOLDER}
                                errorText={formErrors?.classNo}
                                onChange={handleDropDown}
                                disabled={isFormReadOnly}
                                dataTestId={'classDropdown'}
                            />
                        </DropdownWrapperMedium>
                    </RowWrapper>
                    <RowWrapper>
                        <DropdownWrapperLarge>
                            <Dropdown
                                label='MOA Size Number'
                                id='sizeNo'
                                options={sizeOptions}
                                value={formValues?.sizeNo?.toString() || OPTIONS_PLACEHOLDER}
                                errorText={formErrors?.sizeNo}
                                onChange={handleDropDown}
                                disabled={isFormReadOnly}
                                dataTestId={'sizeDropdown'}
                            />
                        </DropdownWrapperLarge>
                    </RowWrapper>
                  { formValues.classNo && formValues.sizeNo && hasImageForm &&
                    <>
                      <HorizontalLine />
                      <ImageForm resourceNo={[formValues.classNo, formValues.sizeNo]} attribute="size" />
                    </>
                  }
                </FormElements>
              { !isFormReadOnly &&
                <Buttons>
                  <Button label='Save' onClick={handleSave} disabled={saveDisabled} isLoading={isButtonLoading}/>
                </Buttons>
              }
            </Form>

        </>
    );
};

export default ClassSizeForm;